export const BASE_TRANSITION = 'all .3s ease';
export const SIDEBAR_WIDTH = 80;
export const SIDEBAR_EXPANDED_WIDTH = 316;
export const APPBAR_HEIGHT = 56;

/**
 * Сдвиг контейнера снекбаров от верха вьюпорта — ТОЛЬКО ниже lg.
 *
 * На десктопе снекбары стоят на штатном месте notistack. Сдвиг там был (18488) и
 * снят осознанно: 128px уводили уведомления слишком низко. Замер подтверждает, что
 * без сдвига уведомление перекрывает строку хедера с полем поиска — это ПРИНЯТО
 * заказчиком (17.09.2026): уведомление живёт несколько секунд и уходит, а поиском
 * в этот момент не пользуются. Не «чинить» обратно, не сверившись с ним.
 *
 * Ниже lg сдвиг остаётся: сверху висит `MobileTopBar` с `position: fixed`, это
 * навигация, которую нельзя отскроллить, и штатные 14px клали уведомление прямо
 * на неё.
 */
export const SNACKBAR_TOP_OFFSET_MOBILE = APPBAR_HEIGHT + 8;
